import {
	ADD_LRP_CART,
	REDUCE_LRP_CART,
	EDIT_LRP_CART,
	REDUCE_LRP_NEWPROMOCODE,
	CHOOSE_LRP_ADDRESS,
	CLEAR_LRP_CART,
	SEL_DAY,
	INIT_BUYLRP,
	SET_STEPINFO,
	SET_UNSAVE,
	SET_LRP_TOTAL,
	SET_LRPSKU,
	REDUCEALL_LRP_CART,
	SET_LRPTCONFIG,
	SET_ISBUY,
	SET_EDIT
} from './mutation-types.js'

export default {
	// 加入购物车

	[ADD_LRP_CART](state, {
		category_id,			
		item_id,
		product_id,
		name,
		price,
		pv,
		pt,
		specs,
		packing_fee,
		sku_id,
		sku,
		stock,
		is_promotion,
		is_new,
		product_number,
		promo_code,
		is_lrpt_product,
		is_hot
	}) {
		var num=product_number?product_number:1;
		let item = (state.cartInfo||[]);
		let citem=item.filter(u=>u.sku==sku&&u.num>0)[0];

		if (citem) {
			citem.num+=num;
			citem.price= price;
			citem.amount=citem.num* price;

		} else 
		{
			citem = {
					'name':name,
					"num" : num,
					"price" : price,
					"pv":pv,
					"pt":pt,
					// "specs" : specs,
					// "packing_fee" : packing_fee,
					"sku" : sku,
					//"stock" : stock,
					"point":0,		//点数兑换金额
					"amount":num*price,		//现金支付金额		
					"selected":false,
					'is_promotion':is_promotion,
					//'is_new':is_new,
					'promo_code':promo_code?promo_code:null,
					'is_lrpt_product':is_lrpt_product,
					'is_hot':is_hot
			};
			item.push(citem)
		}
		state.cartInfo = [...item];
	},

	// 修改购物车
	[EDIT_LRP_CART](state,{sku,num,price}) 
	{
		let item = (state.cartInfo||[]);
		var citem=item.filter(u=>u.sku==sku&&u.num>0)[0];
	
		if(citem){
			citem.num=num;
			citem.amount=price*num;
			citem.price=price;
		}
		
		state.cartInfo=[];
		state.cartInfo =item;

		
	},
	[REDUCEALL_LRP_CART](state,model){
		let cart = (state.cartInfo||[]);
		cart.forEach((item)=>{
			if (item.is_lrpt_product==20&&item.num>0) {
				item.num=0
			}
		})
		state.cartInfo=[];
		state.cartInfo = cart;
		
	},
	[REDUCE_LRP_CART](state, sku) {
		let cart = (state.cartInfo||{});
		let item = (cart[sku] || null);
		if (item) {
			if (item['num'] > 0) {
				item['num']--;
				let lpt = item['point'] - item['pt'];
				if(lpt <= 0){
					if(item['amount']>0){
						item['amount'] = item['amount'] - item['price'];
					}
					else{
						item['amount'] = 0;
					}
					item['point'] = 0;
				}
				else{
					item['point'] = lpt;
				}
				state.cartInfo={};
				state.cartInfo = cart;
			} else {				
				//商品数量为0，则清空当前商品的信息
				item['num'] =0;
				state.cartInfo={};
				state.cartInfo = cart;
			}
		}
		//state.unSave.cartInfo = true;
		//console.log(state.cartInfo)
		//setStore('buyCart', state.cartInfo);
	},
	[REDUCE_LRP_NEWPROMOCODE](state,item){
		var list=state.newpromoCode[item];
		list=null
		state.newpromoCode={...list}
	},
	//选择的地址
	[CHOOSE_LRP_ADDRESS](state, {
		address,
		index
	}) {
		
		state.choosedAddress = address;
		state.addressIndex = index;
		//state.unSave.choosedAddress = true;
	},
	[CLEAR_LRP_CART](state) {
		state.cartInfo  = [];
		//state.unSave.cartInfo = true;
		//setStore('sysConfig', state.sysConfig);
	},
	[SEL_DAY](state,day){
		state.selDay = day;
		//state.unSave.selDay = true;
	},
	//网页初始化时从本地缓存获取购物车数据
	[INIT_BUYLRP](state,cartInfo) {
		 
		 let arry=[];
		 if(cartInfo!=null){
			Object.values(cartInfo).forEach(item=>{
				arry.push(item)
			 })
		 }
		 state.cartInfo=[];
		 state.cartInfo=arry;
		// console.log(cartInfo)
		// state.cartInfo.value = cartInfo;
	},
	[SET_STEPINFO](state,info){
		state.stepInfo=info;
		
	},
	[SET_UNSAVE](state,info){
		
		state.unSave=info;
	},
	[SET_LRPSKU](state,info){
		state.lrpSku=info;
	},
	[SET_LRPTCONFIG](state,info){
		state.lrptConfig=info;
	},
	[SET_ISBUY](state,result){
		state.isBuy=result;
	},
	[SET_EDIT](state,result){
		state.edit=result;
	},
	//设置购物车的汇总信息
	[SET_LRP_TOTAL](state, {
		delivery_fee,
		service_fee,
		ar_value
		//,pay_fee
	}) {
		let cart = (state.cartInfo||{});
		let val = cart.value = (cart.value || {}); 			
		let list = val.detail = (val.detail || {});
		
		val.num = 0;								//购买产品总数（包括兑换的数量）
		val.total_price = 0;						//总的产品销售价格总和 ＝ price（各种产品的）＊num
		val.total_pv = 0;         					//总的产品的point value      		
		val.total_change_point =  0;				//订单兑换PT总和
		val.total_change_point_num = 0; 			//item.num - (item.amount / item.price);    	//订单兑换的产品数量            		
		val.total_product_amount = 0; 				//订单产品需要支付的总和 = total_price - total_change_point_num ＊ 						
		val.delivery_fee = val.delivery_fee || 0;						//快递费
		val.service_fee = val.service_fee || 0;						//服务费
		val.ar_value = val.ar_value || 0;								//AR支付金额		
		val.pay_fee = val.pay_fee || 0;								//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
		
		Object.values(list).forEach(categoryItem => {
			
            Object.values(categoryItem).forEach(itemValue=> {
                Object.values(itemValue).forEach(item => {
                		let ppt = item.pt > 0 ? item.point / item.pt : 0;
                		val.num += item.num;							//购买产品总数（包括兑换的数量）
                		val.total_price += item.num * item.price;	//总的产品销售价格总和 ＝ price（各种产品的）＊num
					    val.total_change_point_num += ppt; //item.num - (item.amount / item.price);    	//订单兑换的产品数量          
                		val.total_pv += (item.num - ppt) * item.pv;         //总的产品的point value      	    		
                		val.total_change_point += item.point;		//订单兑换PT总和                		  		
                		val.total_product_amount += (item.num - ppt) * item.price; //订单产品需要支付的总和 = (item.num - item.point / item.pt) * item.price（兑换的产品价格）
                		
                })
            })
      	});
       
	    	val.delivery_fee = delivery_fee;			//快递费
	    val.service_fee = service_fee;				//服务费
	    val.ar_value = ar_value;					//AR支付金额
	    	
	    var tt = val.total_product_amount + val.delivery_fee + val.service_fee - val.ar_value;
	    val.pay_fee = tt;							//最终支付金额 ＝ total_product_amount+delivery_fee+service_fee - ar_value
    	
		state.cartInfo = {...cart};
	},
	
}
